// extracted by mini-css-extract-plugin
export default {"captcha":"Captcha_captcha__BTPeBsdg","error":"Captcha_error__VntmaiSy"};